import { render, staticRenderFns } from "./userActionItemDetail.vue?vue&type=template&id=0f52b732&scoped=true&"
import script from "./userActionItemDetail.vue?vue&type=script&lang=js&"
export * from "./userActionItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./userActionItemDetail.vue?vue&type=style&index=0&id=0f52b732&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52b732",
  null
  
)

export default component.exports